const endpoint = property => `/api/${property}/offer`;
const periodsendpoint = (property, id) => `/api/${property}/offer/${id}/periods`;

export default ['api', '$rootScope', function (api, $rootScope) {
    const getById = offerId => {
        return api.get(`${endpoint(api.property())}/${offerId}`).then(response => response.data);
    };

    return {
        save: offer => {
            let url = offer.id ? `${endpoint(api.property())}/${offer.id}` : endpoint(api.property());

            return api.upload(url, offer).then(response => response.data);
        },
        savePeriods: (data, offerId) => {
            return api.post(periodsendpoint(api.property(), offerId), data).then(response => response.data);
        },
        delete: offerId => api.delete(`${endpoint(api.property())}/${offerId}`),
        findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
            return api.get(endpoint(api.property()) + (page ? '?page=' + (page) + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).
                then(response => response.data);
        },
        findById: offerId => {
            return getById(offerId);
        },
        toggleActive: offerId => {
            return api.get(`${endpoint(api.property())}/status/${offerId}`)
                .then(response => response.data);
        },
        search: (type, text, page = null) => {
            return api.get(`${endpoint(api.property())}?type=${type}&text=${text}` + (page ? '&page=' + page : '')).then(response => response.data);
        },
        getDetails: offerId => {
            return getById(offerId);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/services/offer.service.js